module.exports = __webpack_public_path__ + "static/flower-179f7d75fc0ef118b110e8f9be093dc0.jpg";